<template>
    <div class="card shadow-none border-0">

        <div class="card-header bg-light">
            Curso de Maternidad y Paternidad Responsable (Embarazo actual No. {{ idEmbarazo }})
        </div>

        <div class="card-body p-1">

            <div class="accordion" id="acordeonSesiones">

                <div
                    v-for="sesion in sesiones"
                    :key="sesion.id"
                    class="card mb-2 shadow-none border-0"
                    style="border-bottom: 1px solid #e9ecef !important;"
                >
                    <!-- Accordion Header -->
                    <div
                        class="p-0 bg-transparent"
                        :id="'headingSesion' + sesion.id"
                    >
                        <button
                            class="btn btn-link btn-block text-left d-flex align-items-center justify-content-between px-2 py-2"
                            type="button"
                            data-toggle="collapse"
                            :data-target="'#collapseSesion' + sesion.id"
                            aria-expanded="false"
                            :aria-controls="'collapseSesion' + sesion.id"
                            style="text-decoration: none; color: inherit;"
                        >
                            <div class="d-flex align-items-center" style="gap: 8px; flex-wrap: wrap;">
                                <span class="font-weight-bold text-primary mr-1" style="font-size: 0.9rem;">
                                    Sesión {{ sesion.numero }}:
                                </span>
                                <!-- <span class="font-weight-bold text-dark" style="font-size: 0.9rem;">
                                    {{ sesion.titulo }}
                                </span> -->
                                <span v-if="sesion.trimestre" class="badge badge-light border text-muted px-2 py-0.5" style="font-size: 0.75rem; border-radius: 4px;">
                                    Trimestre {{ sesion.trimestre }}
                                </span>
                                <span
                                    class="small ml-2 font-weight-bold"
                                    :class="sesion.realizada === 'S' ? 'text-success' : 'text-muted'"
                                >
                                    <i :class="sesion.realizada === 'S' ? 'fas fa-check-circle' : 'far fa-circle'" class="mr-1"></i>
                                    {{ sesion.realizada === 'S' ? 'Realizada' : 'No realizada' }}
                                </span>
                            </div>
                            <div class="d-flex align-items-center text-gray-500" style="gap: 12px; flex-shrink: 0; font-size: 0.8rem;">
                                <span v-if="sesion.fecha">
                                    <i class="far fa-calendar-alt mr-1"></i>
                                    {{ sesion.fecha | formatDate }}
                                </span>
                                <span v-if="sesion.nombre_usuario">
                                    <i class="fa fa-user-md mr-1"></i>
                                    {{ sesion.nombre_usuario }}
                                </span>
                                <i class="fas fa-chevron-down" style="font-size: 0.75rem;"></i>
                            </div>
                        </button>
                    </div>

                    <!-- Accordion Body -->
                    <div
                        :id="'collapseSesion' + sesion.id"
                        class="collapse"
                        :aria-labelledby="'headingSesion' + sesion.id"
                        data-parent="#acordeonSesiones"
                    >
                        <div class="card-body pt-3 pb-3 px-3 border-top-0">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <div class="pl-2" style="border-left: 3px solid #dee2e6;">
                                        <span class="text-muted font-weight-bold d-block mb-1" style="font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.5px;">
                                            <i class="fas fa-book-open text-muted mr-1"></i> Temáticas
                                        </span>
                                        <div class="text-dark" style="white-space: pre-line; font-size: 0.9rem; line-height: 1.4;">
                                            {{ sesion.tematica || '—' }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="pl-2" style="border-left: 3px solid #dee2e6;">
                                        <span class="text-muted font-weight-bold d-block mb-1" style="font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.5px;">
                                            <i class="fas fa-walking text-muted mr-1"></i> Ejercicios
                                        </span>
                                        <div class="text-dark" style="white-space: pre-line; font-size: 0.9rem; line-height: 1.4;">
                                            {{ sesion.ejercicios || '—' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="sesion.observaciones" class="row mt-2">
                                <div class="col-12">
                                    <div class="pl-2" style="border-left: 3px solid #17a2b8;">
                                        <span class="text-muted font-weight-bold d-block mb-1" style="font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.5px;">
                                            <i class="far fa-comment-dots text-muted mr-1"></i> Observaciones
                                        </span>
                                        <div class="text-dark font-italic" style="white-space: pre-line; font-size: 0.9rem; line-height: 1.4;">
                                            {{ sesion.observaciones }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3 text-right">
                                <button
                                    type="button"
                                    class="btn btn-outline-primary btn-sm px-3"
                                    @click="abrirSesion(sesion)"
                                >
                                    <i :class="finalizada === 'S' ? 'far fa-eye' : 'far fa-edit'" class="mr-1"></i>
                                    {{ finalizada === 'S' ? 'Ver detalle' : 'Registrar / Editar sesión' }}
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <modal-sesion
            ref="modalSesion"
            :id-historia="idHistoria"
            :id-embarazo="idEmbarazo"
            :finalizada="finalizada"
            @saved-session="cargarSesiones"
        />

    </div>
</template>
<script>

import { listHistoriaSesiones } from '@/services/cursoMaternidadService';
import ModalSesion from './modalSesion.vue';

export default {

    props: ['idHistoria', 'idEmbarazo', 'finalizada'],

    components: {
        ModalSesion
    },

    data() {
        return {
            sesiones: [],
        }
    },

    watch: {
        idEmbarazo: {
            handler: async function (newVal) {
                if (newVal) {
                    await this.cargarSesiones();
                }
            },
            immediate: true
        }
    },

    methods: {

        async cargarSesiones() {
            if (!this.idEmbarazo) return;

            const response =
                await listHistoriaSesiones(this.idEmbarazo);

            this.sesiones = response.data;

        },

        abrirSesion(sesion) {

            this.$refs.modalSesion.open(sesion);

        },

        retornar() {

            return this.sesiones;

        }

    }

}
</script>